// https://redux.js.org/usage/usage-with-typescript#type-checking-middleware
// @ts-nocheck
import type { Middleware } from '@reduxjs/toolkit';
import { getLaunchDarklyClient } from '../../services/launchDarklyClient';
import { AuthActions, featureFlagIdentitySet } from '../auth';

export const setFeatureFlagContext: Middleware = (store) => (next) => async (action) => {
  if (action.type === AuthActions.FETCH_AUTH_SESSION_FULFILLED) {
    try {
      const payload = action.payload;
      if (payload.email && payload.userId && payload.groups) {
        const launchDarklyClient = getLaunchDarklyClient();
        const identity = {
          key: payload.userId,
          email: payload.email,
          custom: {
            groups: payload.groups,
            givenName: payload.givenName,
            familyName: payload.familyName,
            organizationIds: payload.organizationIds,
            organizationAdminIds: payload.organizationAdminIds,
          },
        };

        await launchDarklyClient.identify(identity);
        store.dispatch(featureFlagIdentitySet());
      }
    } catch {
      // swallow LaunchDarkly identify errors
    }
  }

  return next(action);
};
